/**
 * Normalizes URLs for consistent comparison and matching.
 * Handles:
 * - Trailing slashes
 * - Protocol (http vs https)
 * - www prefix
 * - Query parameters and hash
 * - URL encoding
 */
export function normalizeUrl(url: string): string {
  try {
    const urlObj = new URL(url);
    
    // Normalize protocol to https
    urlObj.protocol = 'https:';
    
    // Remove www prefix
    if (urlObj.hostname.startsWith('www.')) {
      urlObj.hostname = urlObj.hostname.substring(4);
    }
    
    // Remove trailing slash from pathname (except root)
    if (urlObj.pathname.length > 1 && urlObj.pathname.endsWith('/')) {
      urlObj.pathname = urlObj.pathname.slice(0, -1);
    }
    
    // Remove query parameters and hash for matching
    urlObj.search = '';
    urlObj.hash = '';
    
    // Decode URL encoding for consistent comparison
    urlObj.pathname = decodeURIComponent(urlObj.pathname);
    
    return urlObj.toString();
  } catch {
    // If URL parsing fails, return original
    return url;
  }
}

/**
 * Checks if two URLs match after normalization
 */
export function urlsMatch(url1: string, url2: string): boolean {
  return normalizeUrl(url1) === normalizeUrl(url2);
}

